import React from 'react';
import PropTypes from 'prop-types';

import { Loader } from '..';
import './styles.scss';

const Button = (props) => (
  <button
    onClick={props.onClick}
    disabled={props.disabled}
    className={`btn ${props.type} ${props.loading ? 'btn_loading' : ''} ${props.disabled ? 'disabled' : ''}`}
  >
    <span>{props.value}</span>
    {props.loading && (
      <Loader type="small-loader" color={props.loaderColor} />
    )}
  </button>
);
Button.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['primary', 'secondary']),
  disabled: PropTypes.bool,
  value: PropTypes.string,
  loading: PropTypes.bool,
  loaderColor: PropTypes.string,
};
Button.defaultProps = {
  onClick: () => {},
  type: 'primary',
  disabled: false,
  value: '',
  loading: false,
  loaderColor: 'dark',
};

export default Button;
